<template>
  <Modal
    v-if="galleryActiveModal === 'EditGalleryModal'"
    @modalClose="onCloseModal"
    size="largest">
    <div class="modal-body no-padding">
      <div class="page-header">
        <div class="title-container">
          <div class="title">
            <div class="title-action">
              <i
                class="fas fa-chevron-left"
                @click.stop="backToGalleriesList">
              </i>
            </div>
            <div class="header-container">
              <div class="title-header">
                <h5>แก้ไขแกลเลอรี</h5>
              </div>
            </div>
          </div>
        </div>
        <div class="actions">
          <small
            class="text-danger mr-3"
            v-if="saveGalleryState.error">
            พบข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองอีกครั้งหรือติดต่อผู้ดูแลระบบ <br>
            {{ error }}
          </small>
          <button
            type="submit"
            class="btn btn-primary show-lg"
            :disabled="galleryHasAnError"
            @click.stop="onSaveButtonClicked">
            บันทึกและตั้งเป็นแกลเลอรี
          </button>
          <button
            type="submit"
            class="btn btn-primary show-sm"
            :disabled="galleryHasAnError"
            @click.stop="onSaveButtonClicked">
            ตั้งเป็นแกลเลอรี
          </button>
          <Dropdown alignment="right">
            <template v-slot:dropdow-button>
              <button
                type="button"
                class="btn btn-outline-dark btn-action m-0 ml-2">
                <i class="fas fa-cog"></i>
              </button>
            </template>
            <div
              class="dropdown-item"
              @click.stop="onDeleteButtonClicked">
              ลบแกลเลอรี
            </div>
          </Dropdown>
          <button
            class="btn-close"
            @click.stop="$store.dispatch('setGalleryActiveModal', null)">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
      <div class="container">
        <PreloaderSection v-if="loadSelectedGalleryState.isLoading" />
        <ErrorMessageGalleryContainer
          v-if="loadSelectedGalleryState.error"
          :error="loadSelectedGalleryState.error"
          redirectLink="/galleries" />
        <GalleryEditingAreaModalComponent
          v-if="!loadSelectedGalleryState.isLoading && selectedGallery"/>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Dropdown from '@/components/Dropdown.vue';
import Modal from '@/components/Modal.vue';
import PreloaderSection from '@/components/PreloaderSection.vue';

import ErrorMessageGalleryContainer from '../components/ErrorMessageGalleryContainer.vue';
import GalleryEditingAreaModalComponent from '../components/GalleryEditingAreaModalComponent.vue';

export default {
  components: {
    Dropdown,
    ErrorMessageGalleryContainer,
    GalleryEditingAreaModalComponent,
    Modal,
    PreloaderSection,
  },
  computed: {
    ...mapGetters([
      'currentGalleryWasEdited',
      'selectedGallery',
      'galleryActiveModal',
      'loadSelectedGalleryState',
      'saveGalleryState',
    ]),
    galleryHasAnError() {
      return this.currentGalleryWasEdited.errors.statusCode;
    },
  },
  methods: {
    ...mapActions([
      'deleteCurrentGallery',
      'destroyCurrentGalleryState',
      'setCurrentGallery',
      'setGalleryActiveModal',
      'saveSelectedGallery',
      'loadAllGalleriesForModal',
    ]),
    async onSaveButtonClicked() {
      await this.saveSelectedGallery();
      await this.setGalleryActiveModal(null);
    },
    async onDeleteButtonClicked() {
      // eslint-disable-next-line no-restricted-globals,no-alert
      if (confirm('แกลเลอรีไม่สามารถกู้คืนได้อีก คุณยืนยันการลบแกลเลอรีนี้หรือไม่')) {
        await this.deleteCurrentGallery(this.selectedGallery.id);
        this.setGalleryActiveModal('ShowGalleriesListModal');
      }
    },
    onCloseModal() {
      this.setGalleryActiveModal(null);
    },
    async backToGalleriesList() {
      await this.loadAllGalleriesForModal(1);
      await this.setGalleryActiveModal('ShowGalleriesListModal');
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/section-container.scss';
.gallery-form {
  margin-top: 10px;
}
textarea {
  min-height: 110px;
}
.show-sm {
  display: none;
}
.btn-close {
  background: transparent;
  border: none;
  outline: none;
  margin-left: 10px;
}

// custom style
.galleryEditChrome {
  .modal-gallery {
    box-shadow: none;
  }
}

.modal-content {
  .page-header {
    display: flex;
    flex-flow: row;
    width: 100%;
    align-items: center;
    padding: 20px 32px 0;
    justify-content: space-between;
    .title-container {
      .title {
        display: flex;
        flex-flow: row;
      }
      .title-header {
        margin-left: 10px;
      }
    }
    i {
      cursor: pointer;
    }
    .actions {
      display: flex;
      flex-flow: row;
    }
  }
}
.alert {
  border-radius: 0.25rem;
}
@media screen and (max-width: 575.98px) {
  .show-lg {
    display: none;
  }
  .show-sm {
    display: block;
  }
  .modal.galleryEditChrome {
    i {
      cursor: pointer;
    }
    .title-header {
      display: none;
    }
    .btn-action {
      display: none;
    }
    .container {
      padding: 0;
      margin-bottom: 30px;
    }
    .modal-content {
      width: 95vw;
      .page-header {
        padding: 12px 13px 0;
        margin-bottom: -20px;
      }
    }
    .section {
      .section-body {
        padding: 0;
      }
    }
  }
}
</style>
